import './subscription-form-info.scss';
import { useTranslation } from 'react-i18next';
import { Calendar, DollarSign, Settings } from 'react-feather';

type Props = {
  title: string;
  price: number;
  fromDate: string;
  toDate: string;
  categories: string;
};

const SubscriptionFormInfo = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className="purchase-subscription-form-info">
      <div className="purchase-subscription-form-title">{props.title}</div>
      <div className="purchase-subscription-form-details">
        <div className="purchase-subscription-form-detail-item">
          <div className="purchase-subscription-form-detail-item-icon">
            <DollarSign size={18} />
          </div>
          <div className="purchase-subscription-form-detail-item-price">
            {props.price ? `₪ ${props.price}` : t('FREE')}
          </div>
        </div>
        <div className="purchase-subscription-form-detail-item">
          <div className="purchase-subscription-form-detail-item-icon">
            <Calendar size={18} />
          </div>
          <div className="purchase-subscription-form-detail-item-date-time">
            <div className="purchase-subscription-form-detail-item-date">{`${props.fromDate}-${props.toDate}`}</div>
          </div>
        </div>
        <div className="purchase-subscription-form-detail-item">
          <div className="purchase-subscription-form-detail-item-icon">
            <Settings size={18} />
          </div>
          <div className="purchase-subscription-form-detail-item-categories">
            <div className="purchase-subscription-form-detail-item-categories-items">{`${props.categories}`}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionFormInfo;
